import React from 'react'
import {HandsOnTable,DateField,MultiSelectDropDown,RadioGroup,Radio, TextBox, DropDown, Label, TextArea, Tab, TabPage, Button, Grid, GridBody, GridHeader, LovComboBox, AddRowButton, DualStateSelector, ControlCenter, NewButton, SaveButton, RefreshButton, DeleteButton, PopulateButton, CheckBox, PopUpPage, IntegerField, NumberField, AdvanceSearch, AdvanceSearchGrid, AdvanceSearchButton } from '../../../BASE/Components'

export function generateDayBookDisplay(componentList, control) {

    return (
        <>
        <ControlCenter item={componentList["CONTROL_CENTER"]} >
            <div className="loading" id="spinner" style={{ display: "none" }}>Loading&#8230;</div>

            <div className="page-header-wrp">
                <div className="title-breadcrumb-wrp">
                    <h1 className="">{componentList["CONTROL_CENTER"].label.schema.value}</h1>
                </div>                
                <div className="row">
                    <div className="col-12 d-flex justify-content-end">
                        <ControlCenter item={componentList["CONTROL_CENTER"]} >

                            <SaveButton className="btn common-btn common-btn-erp btn-sm mr-2" item={componentList["buttonSave"]}><i className="far fa-save fa-lg"></i></SaveButton>
                        </ControlCenter>
                    </div>
                </div>
            </div>

            <PopUpPage item={componentList["AddPaymentTypePopUp"]} headerText="Add Payment Type" className="AddPaymentType">
                <div className="loading" id="spinnerPopUp" style={{ display: "none" }}>Loading&#8230;</div>
                <div className="col-12 form-row" style={{marginTop:"10px"}}>
                    <div className='="form-group row col-md-12 col-12'>

                        <div className='col-md-12'>
                            <Label item={componentList["inputAddPaymentType"].label} />
                            <TextBox item={componentList["inputAddPaymentType"]} className="form-control form-control-sm" />
                        </div>
                        <div className='col-md-12' style={{textAlign:"right", marginTop:"10px"}}>
                            <Button className="btn common-btn btn-sm" item={componentList["buttonSavePaymentType"]} style={{ marginLeft: "5px" }}><i className="fas fa-save" style={{paddingRight:"10px"}}></i>Save</Button>
                        </div>
                       
                        
                    </div>
                    

                </div>
                
            </PopUpPage>

            <div className="container-fluid custom-container-padding">
                <div className="form-wrp background-white">
                    <div className="row">
                        <div className="col-12">
                            <div className="form-row">
                                <div className="form-group col-md-2 col-sm-12">
                                    <Label item={componentList["inputDate"].label} />
                                    <DateField item={componentList["inputDate"]} dateFormat="yyyy-MM-dd" />
                                </div>
                                <div className="col-md-4 col-sm-12">
                                    <Label item={componentList["inputPaymentType"].label} />
                                    <div className="d-flex align-items-center w-100">
                                        <div className="flex-grow-1 mr-1" style={{ minWidth: 0 }}>
                                            <MultiSelectDropDown
                                                item={componentList["inputPaymentType"]}
                                                className="form-control form-control-sm w-100"
                                            />
                                        </div>
                                        <Button className="btn common-btn common-btn-erp btn-sm" item={componentList["buttonAddPaymentType"]} style={{ marginLeft: "5px" }}><i className="fas fa-plus"></i></Button>
                                    </div>
                                </div>
                                <div className="form-group col-md-4" >
                                    <Label item={componentList["inputPayee"].label} />
                                    <TextBox item={componentList["inputPayee"]} className="form-control form-control-sm" />
                                </div>
                                <div className="form-group col-md-2 mb-0" style={{textAlign:"left", paddingTop:"25px"}}>
                                    <RadioGroup item={componentList["radioPaymentMethod"]}>
                                        <div className="form-check form-check-inline">
                                            <Radio item={componentList["radioPaymentMethod"]} itemName="radioCash" className="form-check-input" />
                                            <label className="form-check-label" htmlFor="radioCash">Cash</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <Radio item={componentList["radioPaymentMethod"]} itemName="radioBank" className="form-check-input" />
                                            <label className="form-check-label" htmlFor="radioBank">Bank</label>
                                        </div>
                                    </RadioGroup>
                                </div>

                                <div className="form-group col-md-6" >
                                    <Label item={componentList["inputRemarks"].label} />
                                    <TextBox item={componentList["inputRemarks"]} className="form-control form-control-sm" />
                                </div>
                                <div className="form-group col-md-4" >
                                    <Label item={componentList["inputAmount"].label} />
                                    <NumberField item={componentList["inputAmount"]} className="form-control form-control-sm" />
                                </div>
                                <div className="form-group col-md-2 mb-0" style={{textAlign:"left", paddingTop:"25px"}}>
                                    <RadioGroup item={componentList["radioDrCr"]}>
                                        <div className="form-check form-check-inline">
                                            <Radio item={componentList["radioDrCr"]} itemName="radioDr" className="form-check-input" />
                                            <label className="form-check-label" htmlFor="radioDr">Dr.</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <Radio item={componentList["radioDrCr"]} itemName="radioCr" className="form-check-input" />
                                            <label className="form-check-label" htmlFor="radioCr">Cr.</label>
                                        </div>
                                    </RadioGroup>
                                </div>
                                
                                {/* <div className="form-group col-md-4" >
                                    <Label item={componentList["inputAddress"].label} />
                                    <NumberField item={componentList["inputAddress"]} className="form-control form-control-sm" />
                                </div>
                                <div className="form-group col-md-4" >
                                    <Label item={componentList["inputAddress"].label} />
                                    <NumberField item={componentList["inputAddress"]} className="form-control form-control-sm" />
                                </div> */}
                                {/* <div className="form-group col-md-3">
                                    <Label item={componentList["inputStyleCode"].label} />
                                    <TextBox item={componentList["inputStyleCode"]} className="form-control form-control-sm" />
                                </div>
                                <div className="form-group col-md-3">
                                    <Label item={componentList["inputFabric"].label} />
                                    <TextBox item={componentList["inputFabric"]} className="form-control form-control-sm" />
                                </div>
                                <div className="form-group col-md-2">
                                    <Label item={componentList["inputMaxPlies"].label} />
                                    <TextBox item={componentList["inputMaxPlies"]} className="form-control form-control-sm" />
                                </div>
                                <div className="form-group col-md-2">
                                    <Label item={componentList["inputMaxLength"].label} />
                                    <TextBox item={componentList["inputMaxLength"]} className="form-control form-control-sm" />
                                </div>
                                <div className="form-group col-md-2">
                                    <Label item={componentList["inputConsumption"].label} />
                                    <TextBox item={componentList["inputConsumption"]} className="form-control form-control-sm" />
                                </div>
                                <div className="form-group col-md-3">
                                    <Label item={componentList["inputType"].label} />
                                    <DropDown item={componentList["inputType"]} className="form-control form-control-sm" />
                                </div> */}


                            </div>
                        </div>
                    </div>
                </div>

                {/* <div className="row pb-4">
                    <div className="col-12">
                        <div className='table-wrp background-white'>
                            <Grid item={componentList["gridSizeFitJson"]} deleteButton={<i className="fa fa-trash"></i>} className="table table-responsive table-striped table-sm w-100 d-block d-md-table">
                                <div className="row">
                                    <div className="col-6">
                                        <div className="master-table-wrp">
                                            <GridHeader typeName="GridHeader" columns={componentList["gridSizeFitJson"].columns} />
                                            <GridBody typeName="GridBody" rows={componentList["gridSizeFitJson"].data} />
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                        </div>
                    </div>
                </div> */}


                {/* Summary Cards */}
                <div className="form-wrp background-white pb-1 pt-2">
                    <div className="row no-gutters">

                        {/* CASH section */}
                        <div className="col-12 px-1 mb-1">
                            <div style={{ fontSize: '10px', fontWeight: 700, color: '#5a5a5a', textTransform: 'uppercase', letterSpacing: '0.6px', borderBottom: '1px solid #e0e0e0', paddingBottom: '2px', marginBottom: '4px' }}>
                                <i className="fas fa-money-bill-wave mr-1"></i>Cash
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4 col-6 px-1 mb-1">
                            <div style={{ borderRadius: '6px', background: '#e8f5e9', borderLeft: '3px solid #43a047', padding: '6px 10px' }}>
                                <div style={{ fontSize: '10px', color: '#2e7d32', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.4px' }}>CR</div>
                                <div style={{ fontSize: '14px', color: '#1b5e20', fontWeight: 700, marginTop: '2px' }}>
                                    {componentList["summaryData"].cashCr.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4 col-6 px-1 mb-1">
                            <div style={{ borderRadius: '6px', background: '#ffebee', borderLeft: '3px solid #e53935', padding: '6px 10px' }}>
                                <div style={{ fontSize: '10px', color: '#c62828', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.4px' }}>DR</div>
                                <div style={{ fontSize: '14px', color: '#b71c1c', fontWeight: 700, marginTop: '2px' }}>
                                    {componentList["summaryData"].cashDr.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4 col-12 px-1 mb-1">
                            <div style={{ borderRadius: '6px', background: componentList["summaryData"].cashNet >= 0 ? '#e8f5e9' : '#ffebee', borderLeft: `3px solid ${componentList["summaryData"].cashNet >= 0 ? '#43a047' : '#e53935'}`, padding: '6px 10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div>
                                    <div style={{ fontSize: '10px', color: componentList["summaryData"].cashNet >= 0 ? '#2e7d32' : '#c62828', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.4px' }}>Net</div>
                                    <div style={{ fontSize: '14px', color: componentList["summaryData"].cashNet >= 0 ? '#1b5e20' : '#b71c1c', fontWeight: 700, marginTop: '2px' }}>
                                        {componentList["summaryData"].cashNet.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </div>
                                </div>
                                <i className={`fas fa-${componentList["summaryData"].cashNet >= 0 ? 'arrow-up' : 'arrow-down'}`} style={{ color: componentList["summaryData"].cashNet >= 0 ? '#43a047' : '#e53935', fontSize: '16px' }}></i>
                            </div>
                        </div>

                        {/* BANK section */}
                        <div className="col-12 px-1 mb-1 mt-1">
                            <div style={{ fontSize: '10px', fontWeight: 700, color: '#5a5a5a', textTransform: 'uppercase', letterSpacing: '0.6px', borderBottom: '1px solid #e0e0e0', paddingBottom: '2px', marginBottom: '4px' }}>
                                <i className="fas fa-university mr-1"></i>Bank
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4 col-6 px-1 mb-1">
                            <div style={{ borderRadius: '6px', background: '#e3f2fd', borderLeft: '3px solid #1e88e5', padding: '6px 10px' }}>
                                <div style={{ fontSize: '10px', color: '#1565c0', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.4px' }}>CR</div>
                                <div style={{ fontSize: '14px', color: '#0d47a1', fontWeight: 700, marginTop: '2px' }}>
                                    {componentList["summaryData"].bankCr.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4 col-6 px-1 mb-1">
                            <div style={{ borderRadius: '6px', background: '#fff3e0', borderLeft: '3px solid #fb8c00', padding: '6px 10px' }}>
                                <div style={{ fontSize: '10px', color: '#e65100', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.4px' }}>DR</div>
                                <div style={{ fontSize: '14px', color: '#bf360c', fontWeight: 700, marginTop: '2px' }}>
                                    {componentList["summaryData"].bankDr.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4 col-12 px-1 mb-1">
                            <div style={{ borderRadius: '6px', background: componentList["summaryData"].bankNet >= 0 ? '#e3f2fd' : '#fff3e0', borderLeft: `3px solid ${componentList["summaryData"].bankNet >= 0 ? '#1e88e5' : '#fb8c00'}`, padding: '6px 10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div>
                                    <div style={{ fontSize: '10px', color: componentList["summaryData"].bankNet >= 0 ? '#1565c0' : '#e65100', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.4px' }}>Net</div>
                                    <div style={{ fontSize: '14px', color: componentList["summaryData"].bankNet >= 0 ? '#0d47a1' : '#bf360c', fontWeight: 700, marginTop: '2px' }}>
                                        {componentList["summaryData"].bankNet.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </div>
                                </div>
                                <i className={`fas fa-${componentList["summaryData"].bankNet >= 0 ? 'arrow-up' : 'arrow-down'}`} style={{ color: componentList["summaryData"].bankNet >= 0 ? '#1e88e5' : '#fb8c00', fontSize: '16px' }}></i>
                            </div>
                        </div>

                        {/* Overall Net Balance */}
                        <div className="col-12 px-1 mt-1 mb-1">
                            <div style={{ borderRadius: '6px', background: componentList["summaryData"].netBalance >= 0 ? '#e8f5e9' : '#ffebee', borderLeft: `3px solid ${componentList["summaryData"].netBalance >= 0 ? '#43a047' : '#e53935'}`, padding: '6px 10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div style={{ fontSize: '10px', color: componentList["summaryData"].netBalance >= 0 ? '#2e7d32' : '#c62828', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                    <i className="fas fa-balance-scale mr-1"></i>Overall Net Balance (CR - DR)
                                </div>
                                <div style={{ fontSize: '14px', color: componentList["summaryData"].netBalance >= 0 ? '#1b5e20' : '#b71c1c', fontWeight: 700 }}>
                                    {componentList["summaryData"].netBalance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    <i className={`fas fa-${componentList["summaryData"].netBalance >= 0 ? 'arrow-up' : 'arrow-down'} ml-2`} style={{ fontSize: '11px' }}></i>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                {/* Transactions Grid */}
                <div className="form-wrp background-white">
                    <div className="scroll-thin txn-summary-grid">
                        <HandsOnTable item={componentList["gridDayBook"]} />
                    </div>
                </div>

            </div>
            </ControlCenter>
        </>
    )
}
